import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const usd = (n) => `$${Number(n).toFixed(2)}`;
const day = (d) => (d && d !== "now" ? new Date(d).toLocaleDateString() : "");

export const ChangePlanDialog = ({ plan, onClose, onDone }) => {
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setP(null); setErr("");
    if (plan) api.post("/billing/change/preview", { plan }).then((r) => setP(r.data)).catch((e) => setErr(e.response?.data?.detail || "Couldn't load this change"));
  }, [plan]);
  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/billing/change", { plan });
      toast.success(data.kind === "downgrade" ? `Change scheduled. You keep Pro until ${day(data.effective)}.` : "Your plan has been updated");
      onDone(data.billing); onClose();
    } catch (e2) { toast.error(e2.response?.data?.detail || "Couldn't change your plan"); }
    finally { setBusy(false); }
  };
  const later = p && (p.kind === "downgrade" || p.kind === "revert");
  return (
    <AlertDialog open={!!plan} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="change-plan-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{p ? `Switch to ${p.label.replace(" (founding price)", "")} · ${p.interval === "year" ? "yearly" : "monthly"}` : "Switch plan"}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm text-muted-ink space-y-2" data-testid="change-plan-summary">
              {err && <p className="text-red-700">{err}</p>}
              {!p && !err && <p>Calculating the exact amount...</p>}
              {p && later && <p>{p.kind === "revert" ? "You'll stay on Pro. Nothing is charged today." : <>Nothing is charged today. You keep Pro until <b>{day(p.effective)}</b>, then you're billed {usd(p.amount)} per {p.interval} for Basic.</>}</p>}
              {p && !later && <>
                <p>Due today: <b className="text-navy" data-testid="change-due-now">{usd(p.due_now)}</b>{p.tax > 0 && <> (includes {usd(p.tax)} tax)</>}</p>
                {p.credit > 0 && <p>Includes a {usd(p.credit)} credit for the unused part of your current plan.</p>}
                <p>Then {usd(p.amount)} per {p.interval}, renewing <b>{day(p.renews_at)}</b>.</p>
                <p>Your new plan starts only after this payment succeeds.</p>
              </>}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="change-plan-cancel-btn">Keep current plan</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={!p || busy} data-testid="change-plan-confirm-btn">{busy ? "Working..." : later ? "Confirm change" : `Pay ${p ? usd(p.due_now) : ""} and switch`}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
